import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export interface DocumentChunk {
  id: string;
  content: string;
  boundingBoxes: Array<{ pageNumber: number; top: number; left: number; width: number; height: number }> | null;
}

interface DocumentChunksResponse {
  data: DocumentChunk[];
  pageCount: number;
  totalCount: number;
  currentPage: number;
  pageSize: number;
}

export const useGetDocumentChunks = (
  caseId: string | null,
  docId: string | null,
  page: number = 1,
  pageSize: number = 50
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocumentChunksResponse>(
    [QueryEntity.Chunk, { caseId, docId, page, pageSize }],
    async () => {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });
      const response = await fetch(
        `${APIBaseChronos}/api/case/${caseId}/docs/${docId}/chunks?${params}`,
        fetchConfigGET
      );
      if (!response.ok) {
        throw new Error('Failed to fetch document chunks');
      }
      return response.json();
    },
    {
      enabled: !!caseId && !!docId,
      refetchOnWindowFocus: false,
    }
  );
};
